<div soho-stepprocess #sohoStepProcessComponent
    *ngIf="panels"
    [linearProgression]="isWizard()"
    [nextButtonLabel] = "nextButtonText"
    [nextButtonEnable] = "isNextEnabled"
    previousButtonLabel="{{'Previous' | translate}}"
    [previousButtonEnable] = "isPreviousEnabled"
    saveAndCloseButtonLabel="{{'SaveAndClose' | translate}}"
    continueButtonLabel="{{'Continue' | translate}}"
    (beforeSelectStep)="onBeforeSelectStep($event)"
    (saveClose)="onSaveClose($event)"
>
  <div soho-step-list-title class="lm-step-list-title">{{'StepsToComplete' | translate}}</div>
  <ul soho-step-list>
    <ng-template ngFor let-panel [ngForOf]="panels" [ngForTrackBy]="trackById">
      <li soho-step-list-item *ngIf="panel.id && !panel.hasSubPanels && !panel.isSubPanel" [isSelected]="isSelected(panel) ">
        <a soho-step-list-item-anchor
            attr.id="{{!testVersion1 ? panel.id + stepPanelTabIdSuffix : null}}"
            stepId="{{panel.id}}"
            [ngClass]="{'is-disabled': !isPanelValid(panel)}"
        >
          <span soho-tooltip [content]="panel.iconInfo" [placement]="'offset'">
            <svg *ngIf="panel.icon === 'empty-circle' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
            <svg *ngIf="panel.icon === 'half-empty-circle' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
            <svg *ngIf="panel.icon === 'success' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
            <svg *ngIf="panel.icon === 'error' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
            <svg *ngIf="panel.icon === 'alert' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
            <svg *ngIf="panel.icon === 'info' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
          </span>
          <span soho-step-list-item-title class="lm-step-list-item-title">{{panel.title}}</span>
          <svg *ngIf="panel.hasSubPanels"
              soho-icon icon="caret-down"
              class="icon-tree"></svg>
        </a>
      </li>
      <li soho-step-list-item *ngIf="panel.id && panel.hasSubPanels && !panel.isSubPanel" [isSelected]="isSelected(panel)">
        <a soho-step-list-item-anchor stepId="{{panel.id}}" [ngClass]="{'is-disabled': !isPanelValid(panel)}">
          <svg *ngIf="panel.icon === 'empty-circle' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
          <svg *ngIf="panel.icon === 'half-empty-circle' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
          <svg *ngIf="panel.icon === 'success' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
          <svg *ngIf="panel.icon === 'error' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
          <svg *ngIf="panel.icon === 'alert' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
          <svg *ngIf="panel.icon === 'info' "soho-icon icon="{{panel.icon}}" class="step-alert" alert="true"></svg>
          <span soho-step-list-item-title class="lm-step-list-item-title">{{panel.title}}</span>
          <svg soho-icon icon="caret-down" class="icon-tree"></svg>
        </a>
        <ul soho-substep-list  *ngIf="panel.subPanels">
          <li soho-step-list-item *ngFor="let subPanel of panel.subPanels; trackBy: trackById" [isSelected]="isSelected(subPanel)" class="lm-step-list-subpanel-item">
            <a soho-step-list-item-anchor stepId="{{subPanel.id}}" [ngClass]="{'is-disabled': !isPanelValid(subPanel)}" soho-tooltip [content]="subPanel.mouseOverText" [placement]="'offset'">
              <span soho-tooltip [content]="subPanel.iconInfo" [placement]="'offset'">
                <svg *ngIf="subPanel.icon === 'empty-circle' "soho-icon icon="{{subPanel.icon}}" class="step-alert" alert="true"></svg>
                <svg *ngIf="subPanel.icon === 'half-empty-circle' "soho-icon icon="{{subPanel.icon}}" class="step-alert" alert="true"></svg>
                <svg *ngIf="subPanel.icon === 'success' "soho-icon icon="{{subPanel.icon}}" class="step-alert" alert="true"></svg>
                <svg *ngIf="subPanel.icon === 'error' "soho-icon icon="{{subPanel.icon}}" class="step-alert" alert="true"></svg>
                <svg *ngIf="subPanel.icon === 'alert' "soho-icon icon="{{subPanel.icon}}" class="step-alert" alert="true"></svg>
                <svg *ngIf="subPanel.icon === 'info' "soho-icon icon="{{subPanel.icon}}" class="step-alert" alert="true"></svg>
              </span>
              <span soho-step-list-item-title class="lm-step-list-item-title">{{subPanel.title}}</span>
            </a>
          </li>
        </ul>
      </li>
    </ng-template>
  </ul>

  <div soho-step-content-title attr.title="{{getCurrentStepTitle()}}" soho-tooltip>
    <div>{{getCurrentStepTitle()}}</div>
    <small>{{getCurrentSubPanelTitle()}}</small>
  </div>

  <div soho-step-content
      soho-busyindicator
      [text]="' '"
      [blockUI]="true"
      [displayDelay]="20"
      [timeToComplete]="this.uiLoadingIndicatorTimeout"
      [transparentOverlay]="true"
  >
    <ng-template ngFor let-panel [ngForOf]="panels" [ngForTrackBy]="trackById" let-i="index">

      <!--
        NOTE: DO NOT use display block here, the step control uses
        display to pop the panels in and out.
      -->`
      <div soho-step-content-panel
          *ngIf="panel.id"
          [ngSwitch]="panel.type"
          stepId="{{panel.id}}"
          [ngStyle]="{'height': '100%'}"
      >
        <lm-form-panel-text
            *ngIf="panel.panelHeader || panel.panelText"
            [panelHeader]="panel.panelHeader"
            [panelText]="panel.panelText"
            [specFields]="specFields"
            [fromDataView]= "panel.isSubPanel ? panel.subPanelDataView : null"
            [model]= "panel.isSubPanel ? null : model"
        ></lm-form-panel-text>
        <lm-form-panel-form *ngSwitchCase="'form'" #panelComponent
          [layout]="panel.layout"
          [formSpec] ="panel.formSpec"
          [formOptions]="panel.formOptions"
          [specFields]="panel?.finishForm ? panel.formSpec.busFormSpec.wizardFinishForm.fields : specFields"
          [placeHolder]="placeHolder"
          [panelId]="panel.id"
          [model]="model"
          [initialized]="true"
          [hideLayout] = "panel.hideLayout"
          [hasPanelText]="panel.panelHeader || panel.panelText ? true : false"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-form-panel-form>
        <lm-form-panel-list #panelComponent
            *ngSwitchCase="'formlist'"
            [listSpec]="panel.listSpec"
            [placeHolder]="placeHolder"
            [fromDataView]="panel.isSubPanel ? panel.subPanelDataView : fromDataView"
            [activated]="panel.activated"
            [panelId]="panel.id"
            [ngStyle]="{'height': '100%', 'display': 'block'}"
            (contentModified)="onContentModified($event)"
            (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
        ></lm-form-panel-list>
        <lm-form-panel-template #panelComponent
            *ngSwitchCase="'templateform'"
            [fromDataView]="fromDataView"
            [sourceDataView]="panel.subPanelDataView"
            [busFormPanel]="panel.busFormPanel"
            [formSpec] ="panel.formSpec"
            [layout]="panel.layout"
            [model]="model"
            [specFields]="panel.formSpec.busFormSpec.fields"
            [displayWhenIndex]="panel.displayWhenIndex"
            [placeHolder]="placeHolder"
            [panelId]="panel.id"
            [hideLayout]="panel.hideLayout"
            (contentModified)="onContentModified($event)"
            (fieldEvent)="onFieldEvent($event)"
            (formPanelContentLoading)="onFormPanelContentLoading($event)"
            (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
        ></lm-form-panel-template>
        <lm-form-panel-independentform #panelComponent
            *ngSwitchCase="'independentform'"
            [activated]="panel.activated"
            [formSpec]="panel.formSpec"
            [placeHolder]="placeHolder"
            [panelId]="panel.id"
            [fromDataView]="fromDataView"
            [hideLayout] = "panel.hideLayout"
            (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
            (contentModified)="onContentModified($event)"
            (fieldEvent)="onFieldEvent($event)"
        ></lm-form-panel-independentform >
        <lm-form-panel-actionis #panelComponent
            *ngSwitchCase="'actionis'"
            [activated]="panel.activated"
            [formSpec]="panel.formSpec"
            [targetAction]="panel.busFormPanel.actionFullName"
            [placeHolder]="placeHolder"
            [panelId]="panel.id"
            [fromDataView]="fromDataView"
            [hideLayout] = "panel.hideLayout"
            (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
            (contentModified)="onContentModified($event)"
            (fieldEvent)="onFieldEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
        ></lm-form-panel-actionis>
        <lm-form-panel-url #panelComponent
            *ngSwitchCase="'url'"
            [panelId]="panel.id"
            [activated]="panel.activated"
            [url]="panel.url"
            [bottomSpacing] = 30
            [isPanelNavigation] = true
            [placeHolder]="placeHolder"
            [fromDataView]="fromDataView"
        ></lm-form-panel-url >
        <lm-form-panel-multilist #panelComponent
            *ngSwitchCase="'multilist'"
            [activated]="panel.activated"
            [sectionSpecs]="panel.sections"
            [placeHolder]="placeHolder"
            [panelId]="panel.id"
            [fromDataView]="fromDataView"
            (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
            (contentModified)="onContentModified($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
            [hasPanelText]="panel.panelHeader || panel.panelText ? true : false"
        ></lm-form-panel-multilist>
        <lm-form-panel-notfound #panelComponent
            *ngSwitchDefault
            [panelId]="panel.id"
            [activated]="panel.activated"
        ></lm-form-panel-notfound>
      </div>
    </ng-template>
  </div>
</div>

<div #dialogPlaceholder id="lmStepProcessDialogPlaceholder" class="lmDialogPlaceholder"></div>
